import { table } from './_table';

export const charges = {
  namespaced: true,
  modules: {
    table
  }
};
